document.addEventListener("DOMContentLoaded", function () {
  const languageLinks = document.querySelectorAll(".js-lang");
  const headerLogo = document.querySelector(".l-header-logo__outer");

  // ロゴのリンクマッピング
  const logoLinkMap = {
    "/": "/",
    "/fr/": "/fr/",
    "/th/": "/th/",
    "/tw/": "/tw/",
  };

  // 言語リンクとナビゲーション、ロゴの更新処理
  function updateLanguageElements() {
    const currentPath = window.location.pathname;

    // 現在の言語を判定
    let currentLang = "/";
    if (currentPath.startsWith("/fr/")) currentLang = "/fr/";
    if (currentPath.startsWith("/th/")) currentLang = "/th/";
    if (currentPath.startsWith("/tw/")) currentLang = "/tw/";

    // ナビゲーションリンクの更新
    languageLinks.forEach((link) => {
      link.classList.remove("--is-here");

      if (
        (currentPath === "/" && link.getAttribute("href") === "/") ||
        (currentPath.startsWith("/fr/") && link.getAttribute("href") === "/fr/") ||
        (currentPath.startsWith("/th/") && link.getAttribute("href") === "/th/") ||
        (currentPath.startsWith("/tw/") && link.getAttribute("href") === "/tw/")
      ) {
        link.classList.add("--is-here");
      }
    });

    // ロゴの href を更新
    if (headerLogo) {
      headerLogo.setAttribute("href", logoLinkMap[currentLang]);
    }
  }

  // 言語リンクにクリックイベントを追加
  languageLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const newUrl = this.getAttribute("href");
      window.location.href = window.location.origin + newUrl;
    });
  });

  // 初期化時にエレメントを更新
  updateLanguageElements();
});
